export class PushNotifIdsModel {
    public ids: number[];
}



// WEBPACK FOOTER //
// ./src/app/core/models/pushNotifToDel.model.ts